const NUMBER_CHAR_RX = /[\d\s]/;

export const numberMask = (value: string) =>
  value
    .split('')
    .filter((c) => NUMBER_CHAR_RX.test(c))
    .map(() => NUMBER_CHAR_RX);
